export default "__VITE_ASSET__902e5612__"